// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"PaymentMethodView_fieldset__QEB59","label":"PaymentMethodView_label__xM6ed","input":"PaymentMethodView_input__vj9M1","select":"PaymentMethodView_select__32jl5"};